export default __webpack_public_path__ + "static/media/Beard_11_C5.6b3937f5.svg";